'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports.latinToPersian = latinToPersian;
exports.persianToLatin = persianToLatin;
exports.arabicToPersian = arabicToPersian;
exports.formatNumber = formatNumber;
exports.formatString = formatString;
exports.removeCommasFromString = removeCommasFromString;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var latinToPersianMap = ['۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '۰'];
var latinNumbers = [/1/g, /2/g, /3/g, /4/g, /5/g, /6/g, /7/g, /8/g, /9/g, /0/g];
var arabicToPersianMap = ['۴', '۵', '۶'];
var arabicNumbers = [/٤/g, /٥/g, /٦/g];
var persianToLatinMap = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
var persianNumbers = [/۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g, /۰/g];

function convertToString(input) {
  return input + '';
}

function latinToPersian(string) {
  string = convertToString(string);
  var result = string;

  for (var index = 0; index < 10; index++) {
    result = result.replace(latinNumbers[index], latinToPersianMap[index]);
  }

  return result;
}

function persianToLatin(string) {
  var result = string;

  for (var index = 0; index < 10; index++) {
    result = result.replace(persianNumbers[index], persianToLatinMap[index]);
  }

  return result;
}

function arabicToPersian(string) {
  string = convertToString(string);
  var result = string;

  for (var index = 0; index < 10; index++) {
    result = result.replace(arabicNumbers[index], arabicToPersianMap[index]);
  }

  return result;
}

// Add comma to every 3 number

function formatNumber(number) {
  var dec = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  number = number.toFixed(2) + '';
  var x = number.split('.');
  var x1 = x[0];
  var x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + (dec ? x2 : '');
}

function formatString(string) {
  var dec = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

  string = convertToString(string);
  var numberString = isNumber(parseInt(string)) && string !== '' ? string : 0;
  return formatNumber(parseInt(numberString), dec) + '';
}

function removeCommasFromString(string) {
  string = convertToString(string);
  return string.split(',').join('');
}

var PersianNumber = (function (_Component) {
  _inherits(PersianNumber, _Component);

  function PersianNumber() {
    _classCallCheck(this, PersianNumber);

    _get(Object.getPrototypeOf(PersianNumber.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(PersianNumber, [{
    key: 'convert',
    value: function convert(string) {
      var result = undefined;
      var _props = this.props;
      var arabic = _props.arabic;
      var latin = _props.latin;
      var format = _props.format;
      var removeCommas = _props.removeCommas;

      if (latin) {
        result = latinToPersian(string);
      }

      if (arabic) {
        result = arabicToPersian(result);
      }

      if (removeCommas) {
        result = removeCommasFromString(result);
      }

      if (format) {
        result = formatString(result);
      }

      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var children = this.props.children;

      if (!(children instanceof Array)) {
        children = [children];
      }

      return _react2['default'].createElement(
        'span',
        null,
        children.map(function (child) {
          if (typeof child === 'string') {
            return _this.convert(child);
          } else if (typeof child === 'number') {
            return _this.convert(child.toString());
          }
          return child;
        })
      );
    }
  }], [{
    key: 'propTypes',
    value: {
      arabic: _propTypes2['default'].bool,
      latin: _propTypes2['default'].bool,
      children: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].string]),
      format: _propTypes2['default'].bool,
      removeCommas: _propTypes2['default'].bool
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      latin: true,
      arabic: false,
      format: false,
      removeCommas: false
    },
    enumerable: true
  }]);

  return PersianNumber;
})(_react.Component);

exports['default'] = PersianNumber;


//////////////////
// WEBPACK FOOTER
// ./~/@thg303/react-persian/lib/PersianNumber.js
// module id = 640
// module chunks = 0